// const rolesPermissions = ['ROL_RRHH','ROL_TITULAR', 'ROL_UNIDAD']
import Vue from "vue";
const rolesPermissions = new Set(JSON.parse(localStorage.getItem('roles')))
const roleDirective = {
  inserted(el, binding, vnode) {
    const { permission, action, ...rest } = binding.value;
    const role = Object.values(rest).join('');
    const hasPermission = rolesPermissions?.has(permission || role);

    // console.log('hasPermission', hasPermission, permission, action);
    // if (!hasPermission) {
      const isVueComponent = vnode.componentInstance;
      const defaultAction = isVueComponent ? 'disable' : 'hide';

      switch (action || defaultAction) {
        case 'hide':
          el.style.display = 'none';
          break;
        case 'disable':
          if (isVueComponent) {
            vnode.componentInstance.$data.disabled = true;
            el.style.pointerEvents = 'none';
            el.firstElementChild.firstElementChild.firstElementChild.style.backgroundColor = '#0000001f'
            el.style.opacity = '0.4';
          } else {
            el.disabled = true;
            el.style.pointerEvents = 'none';
            el.style.opacity = '0.4';
          }
          break;
        case 'show':
          break;
        default:
          if (isVueComponent) {
            vnode.componentInstance.$data.disabled = true;
            el.style.pointerEvents = 'none';
            el.firstElementChild.firstElementChild.firstElementChild.style.backgroundColor = '#0000001f'
            el.style.opacity = '0.4';
          } else {
            el.disabled = true;
            el.style.pointerEvents = 'none';
            el.style.opacity = '0.4';
          }
          console.warn(`Acción desconocida: ${action}`);
      }
    // } else {
    //   el.style.display = 'none';
    // }
  }
};

export { roleDirective };
